export default "__VITE_ASSET__46767e16__"